import { Lock, Pencil, ShoppingBag } from 'lucide-react';
import { clsx } from 'clsx';
import { datumZeitDe } from '@/lib/format';

// Der Badge beschreibt, WOHER der Datensatz stammt, den man vor sich hat.
// Bei einer Shop-Bestellung ist das die Bestellung selbst — auch dann,
// wenn der Kunde dahinter schon laenger im Tracking gepflegt wird. Frueher
// stand hier stur die Kundenherkunft, sodass eine Webhook-Bestellung mit
// bekanntem Kunden "Im Tracking erfasst" zeigte.
type Props = {
  quelle: 'tracking' | 'bonus' | 'shopify';
  syncedAt: string | null;
  /** Setzt den Badge auf "Aus Shopify", unabhaengig von der Kundenherkunft. */
  ausShopify?: boolean;
};

function syncZeit(iso: string | null): string {
  return iso ? datumZeitDe(iso) : 'unbekannt';
}

export function KundenQuelleBadge({ quelle, syncedAt, ausShopify = false }: Props) {
  const isShopify = ausShopify || quelle === 'shopify';
  const isBonus = !isShopify && quelle === 'bonus';

  if (isShopify) {
    return (
      <span
        className="inline-flex items-center gap-1.5 rounded-full border border-teal px-2 py-0.5 text-xs text-teal"
        title="Über den Shop hereingekommen und automatisch angelegt."
      >
        <ShoppingBag className="h-3 w-3" />
        Aus Shopify
      </span>
    );
  }

  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-xs',
        isBonus
          ? 'border-teal text-teal'
          : 'border-gold-dark text-gold-dark'
      )}
      title={
        isBonus
          ? `Stammdaten kommen aus BONUS, in BONUS pflegen. Letzter Sync: ${syncZeit(syncedAt)}.`
          : 'Im Tracking erfasst — bitte später in BONUS nachpflegen.'
      }
    >
      {isBonus ? <Lock className="h-3 w-3" /> : <Pencil className="h-3 w-3" />}
      {isBonus ? 'Aus BONUS' : 'Im Tracking erfasst'}
    </span>
  );
}
